// extracted by mini-css-extract-plugin
module.exports = {"section":"k_1-SCo","inner":"k_dt7tG","wrap":"k_1NZ6l","imageBlock":"k_1RbmA","appList":"k_1L40m"};